export default __webpack_public_path__ + "static/media/decline_call.c5187692.svg";